import { List, Tile, getImageByOrientation } from "@blacknut/javascript-sdk/dist";
import { useAnalytics } from "core";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@blacknut/react-sdk/dist";
import FadeInImage from "../FadeInImage/FadeInImage";
import { Focusable } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import styles from "./styles.module.scss";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
import { useOrientation } from "src/utils/OrientationContext";
import { useScrollContext } from "src/utils/scroll/ScrollProvider";

interface RandomTileProps {
  item: Tile;
  list: List;
  className?: string;
  inView: boolean;
}

const RandomTile = ({ list, className, inView = true }: RandomTileProps) => {
  const { t } = useTranslation();
  const { trackSurpriseMe } = useAnalytics();

  const { navigate } = useAppNavigation();
  const _onClick = useCallback(() => {
    const idx = Math.floor(Math.random() * list.tiles.length);
    navigate(`/game/${list.tiles[idx].game?.id}`);
    trackSurpriseMe();
  }, [navigate, list.tiles, trackSurpriseMe]);

  const { orientation } = useOrientation();
  const imgBackground = getImageByOrientation(orientation, list.imgBackground ?? []);

  const { update: updateScrollContext } = useScrollContext();
  const onFocus = useCallback(
    (e: React.FocusEvent<HTMLDivElement, Element>) => {
      const selector = "." + [...e.target.classList].join(".");
      updateScrollContext(selector);
    },
    [updateScrollContext],
  );

  return (
    <Focusable
      className={clsx(styles.container, styles.focusable, className)}
      onClick={_onClick}
      onPressEnter={_onClick}
      onFocus={onFocus}
    >
      {inView && <FadeInImage image={imgBackground} className={styles.image} />}
      <div className={styles.textContainer}>
        <span className={styles.title}>{t("randomTile.text")}</span>
        <Button className={styles.button} variant="primary" onClick={_onClick} disabled>
          {t("randomTile.button")}
        </Button>
      </div>
    </Focusable>
  );
};

export default RandomTile;
